export default "__VITE_ASSET__15205da0__"